import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=59635986&scoped=true"
import script from "./prize.vue?vue&type=script&lang=js"
export * from "./prize.vue?vue&type=script&lang=js"
import style0 from "./prize.vue?vue&type=style&index=0&id=59635986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59635986",
  null
  
)

export default component.exports